<template>
  <div>
    <v-row dense no-gutters cols="12">      
      <v-col cols="5">
        <v-row dense>
          <v-col cols="12">
            <re_radioset :value="wizardData.weekprice_relative" field="weekprice_relative" @updateData="updateData"/>
          </v-col>
        </v-row>
        <v-row dense class="ml-3">
          <div v-if="wizardData.weekprice_relative===true">
          <hsnp_wizard_step_02_weekprice_relative :wizardData="wizardData" @updateData="updateData" class="ml-3"/>
        </div>
        <div v-else>
          <hsnp_wizard_step_02_weekprice_exact :wizardData="wizardData" @updateData="updateData" class="ml-3"/>
        </div>
        </v-row>
      </v-col>
      <v-col cols="6" class="mt-3">
        <weekdays :days="wizardData.weekprice_days" field="weekprice_days" color="primary" @updateData="updateData" class="ml-3"/>
      </v-col>
    </v-row>

  </div>      
</template>

<script>
  
  import weekdays from '@/components/huis/hspt/ui/weekdays.vue'
  import re_radioset from '@/components/huis/hspt/ui/re_radioset.vue';
  import hsnp_wizard_step_02_weekprice_relative from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_weekprice_relative.vue';
  import hsnp_wizard_step_02_weekprice_exact from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_weekprice_exact.vue';  

  export default {
    props: {
      wizardData: Object
    },
    components: {
      weekdays,
      re_radioset,
      hsnp_wizard_step_02_weekprice_relative,
      hsnp_wizard_step_02_weekprice_exact,
    },
    methods:{
      updateData(data){
        this.$emit('updateData', data);     
      }      
    }

  }
</script>

<style scoped>
</style>